import React from "react";
import { createRoot } from "react-dom/client";
// import App from "./App";
import dayjs from "dayjs";
import "dayjs/locale/sq";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { RouterProvider } from "react-router-dom";
import { setupAxios } from "./config/axios";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import router from "./router/Router";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Europe/Belgrade");

setupAxios();

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
